__webpack_require__.p = "/columnists/wp-content/themes/beliefnet-twentyeighteen/assets/app/dist/";